module.exports = __webpack_public_path__ + "static/media/1010244.ff45f93a.jpg";